import React, { FC, useContext } from 'react';
import { InstallableAppCard } from '../InstallableAppCard/InstallableAppCard';
import { AddNewAppCard } from '../AddNewAppCard/AddNewAppCard';
import { Channel, InstallableApp } from '../../model/skill';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { Context as AppStoreSnapshotContext } from '../../context/appStoreSnapshotContext';

import styles from './InstallableAppCardList.module.scss';

interface InstallableAppCardListProps {
    onAppCreate: (channel: Channel) => void;
    channel: Channel;
}

function byUpdateTime(l: InstallableApp, r: InstallableApp) {
    const lUpdateTime = new Date(l.draft.updatedAt).getTime();
    const rUpdateTime = new Date(r.draft.updatedAt).getTime();

    return lUpdateTime - rUpdateTime;
}

export const InstallableAppCardList: FC<InstallableAppCardListProps> = ({ onAppCreate, channel }) => {
    const { appStoreSnapshot } = useContext(AppStoreSnapshotContext);
    const installableAppCard: InstallableApp[] = (appStoreSnapshot?.installableApps ?? []).filter(
        (installableApp) => installableApp.channel === channel,
    );
    return (
        <ErrorBoundary withHomepageLink>
            <div className={styles.installableAppCardList}>
                <AddNewAppCard onAppCreate={onAppCreate} channel={channel} />
                {installableAppCard.sort(byUpdateTime).map((installableApp) => (
                    <InstallableAppCard key={installableApp.id} installableApp={installableApp} />
                ))}
            </div>
        </ErrorBoundary>
    );
};
